import { colors } from '../theme';

// Static demonstration figures for the landing dashboard's summary cards. No API serves these yet;
// keeping them here (not inside the page) means a future endpoint replaces this module, not the page.

export const CLAIMS_HEALTH = {
    total: 1600,
    data: [
        { label: 'Approved', value: 1225, color: colors.primary },
        { label: 'Rejected', value: 250, color: colors.danger },
        { label: 'Pending', value: 125, color: colors.accentSoft }
    ],
};

export const COST_STATISTICS = {
    total: 75000,
    data: [
        { label: 'Parts', value: 45000, color: colors.primary },
        { label: 'Labor', value: 25000, color: colors.accent },
        { label: 'Other', value: 5000, color: colors.accentSoft }
    ],
};

export const WEEKLY_TRENDS = {
    total: 180,
    data: [
        { label: 'This Week', value: 180, color: colors.primary },
        { label: 'Last Week', value: 165, color: colors.accent },
        { label: 'Avg', value: 150, color: colors.accentSoft }
    ],
};

// Insight cards: high-probability rejection alert, processing efficiency tip, data anomaly tip.
export const INSIGHTS = [
    'ML Alert: 12 pending claims flagged with high rejection probability. Review data extraction for missing fields.',
    'Workflow Efficiency: Automated validation has reduced claim cycle time by 18% this week.',
    'Anomaly Detected: Unusual spike in warranty claims for "Drive Train" components in the East Region.',
];
